import React from 'react';
import TodoCard from './TodoCard';

export default function TodoGrid({ title, todos = [], completedTodos = {}, onToggleTodo }) {
    if (!todos || todos.length === 0) return null;

    return (
        <div>
            {title && <h2 className="section-title mb-4">{title}</h2>}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {todos.map((todo, i) => (
                    <TodoCard
                        key={i}
                        title={todo.title}
                        note={todo.note}
                        url={todo.url}
                        isCompleted={!!completedTodos[todo.title]}
                        onToggle={(val) => onToggleTodo(todo.title, val)}
                    />
                ))}
            </div>
        </div>
    );
}
